import React from 'react';
import { Image } from 'react-bootstrap';
import '../content/css/LoadingIcon.css';

var icon = require("../content/images/icon_color_loading.gif");

export const LoadingIcon = (props) => (
    <Image className={`loading-icon ${props.isFixed ? 'fixed' : ''}`} src={icon} />
)


// WEBPACK FOOTER //
// ./src/components/LoadingIcon.js